import styled from "styled-components";
import { Check, HandHeart } from "@phosphor-icons/react";

import Reveal from "./Shared/Reveal";
import { Container, Section, Eyebrow, H2, Lead } from "./Shared/ui";

const OBJECTIVES = [
  "Carry out community development projects.",
  "Establish, conduct, manage and participate in educational, charitable, social and cultural activities by forming societies or similar associated concerns or organizations.",
  "Subscribe aid, donate, or subsidize any work, organizations or institutes having same or similar objectives in promotion of the objectives of the society.",
  "Organize events for the promotion of sports, arts, literary and other programmes among the members.",
  "Provide opportunity for the upcoming talented peoples from the community.",
  "Convene family gatherings on a regular basis to motivate all sections of the people especially women and children for greater accomplishments in their life.",
];

const SERVICES = [
  "State Resource Centre Study Centre",
  "Vinayaka Matrimonial",
  "Career Forum",
  "Medical Camps",
  "Scholarships",
  "Womens Forum",
  "Campaigns",
];

const OFFICE_BEARERS = [
  { role: "Chairman", people: [["O. Mohanan", "Managing Director, G Sons Group"]] },
  {
    role: "Chief Patron",
    people: [
      ["Shri C. Jayachandran", "Managing Partner, Mascot Industries & Textile Exports"],
      ["Shri Pala Balan", "Textile Consultant"],
    ],
  },
  { role: "Vice Chairman", people: [["Madhu Aeran", "Surveyor / Loss Assessor"]] },
  { role: "General Secretary", people: [["Shri C. Ramakrishnan", "Managing Director, C R Group of Companies"]] },
  {
    role: "Secretaries",
    people: [
      ["T. Padmanabhan", "Head Master (Rtd.)"],
      ["T S Ramachandran", "Thiruvangadan Group of Companies"],
    ],
  },
  { role: "Treasurer", people: [["Dinesh Alingal", "Managing Partner, Dream Home"]] },
  {
    role: "Board / Executive members",
    wide: true,
    people: [
      ["Rajan Azhikodan", "Chartered Engineer"],
      ["P Chandran", "Ex-NRI"],
      ["Mohana Chandran", "Manager, Oriental Insurance"],
      ["K Unnikrishnan", "Advocate"],
    ],
  },
];

const About = () => {
  return (
    <Section id="about">
      <Container>
        <Reveal>
          <Eyebrow>About us</Eyebrow>
          <H2>About Vinayaka Matrimony</H2>
          <Lead>
            Pioneered by Vinayaka Foundation a decade ago as part of its social commitment,
            Vinayaka Matrimony has helped hundreds find matches from across different communities.
            The services provided by our matrimonial wing have made the site the most popular one among Keralites.
          </Lead>
        </Reveal>

        <Bento>
          <Reveal className="tile tile-foundation" index={0}>
            <HandHeart size={36} weight="duotone" />
            <h3>Vinayaka Foundation</h3>
            <h4>The team behind Vinayaka Matrimony</h4>
            <p>
              Vinayaka Foundation is an organization registered under the societies act, meant for
              doing charitable activities for the poor and needy in our society.
            </p>
            <p className="note">
              Its activities were formally inaugurated by Olympian Padmashree Dr. P.T. Usha on 1 November 2008.
            </p>
          </Reveal>

          <Reveal className="tile tile-objectives" index={1}>
            <h3>Our objectives</h3>
            <ul>
              {OBJECTIVES.map((item) => (
                <li key={item}>
                  <Check size={18} weight="bold" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal className="tile tile-services" index={2}>
            <h3>Our services</h3>
            <Pills>
              {SERVICES.map((service) => (
                <li key={service}>{service}</li>
              ))}
            </Pills>
          </Reveal>
        </Bento>

        <Leadership>
          <Reveal>
            <h3>Office bearers</h3>
            <p>
              We welcome all good hearted friends with a desire for service from the Saliya, Pattarya,
              Devanga, Pillai and other communities to become our members. There are three types of
              membership: Patron member, Life member and Ordinary member. For details, please contact
              any of our office bearers or a member close to your place.
            </p>
          </Reveal>

          <Directory>
            {OFFICE_BEARERS.map(({ role, people, wide }, i) => (
              <Reveal key={role} index={i % 4} className={wide ? "wide" : ""}>
                <Role>{role}</Role>
                <People $wide={wide}>
                  {people.map(([name, title]) => (
                    <li key={name}>
                      <strong>{name}</strong>
                      <span>{title}</span>
                    </li>
                  ))}
                </People>
              </Reveal>
            ))}
          </Directory>
        </Leadership>
      </Container>
    </Section>
  );
};

const Bento = styled.div`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  grid-auto-rows: auto;
  gap: 20px;
  margin-top: clamp(40px, 5vw, 56px);

  .tile {
    border-radius: var(--radius-card);
    padding: clamp(24px, 3vw, 40px);
    min-width: 0;
  }

  .tile h3 {
    font-size: 24px;
    margin-bottom: 18px;
  }

  .tile-foundation {
    grid-column: span 5;
    grid-row: span 2;
    color: rgb(254 254 254 / 0.86);
    background:
      radial-gradient(120% 80% at 100% 0%, rgb(247 108 108 / 0.35) 0%, transparent 55%),
      linear-gradient(160deg, var(--indigo) 0%, var(--navy) 100%);
    display: flex;
    flex-direction: column;

    svg {
      color: var(--butter);
      margin-bottom: auto;
      padding-bottom: 48px;
      box-sizing: content-box;
    }

    h3 {
      color: #fefefe;
      font-size: clamp(28px, 3vw, 36px);
      margin-bottom: 6px;
    }

    h4 {
      color: var(--butter);
      font-family: var(--font-body);
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0;
      margin-bottom: 20px;
    }

    .note {
      margin: 8px 0 0;
      padding-top: 20px;
      border-top: 1px solid rgb(254 254 254 / 0.18);
      font-size: 15px;
    }
  }

  .tile-objectives {
    grid-column: span 7;
    background: var(--surface);
    border: 1px solid var(--border);

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px 28px;
    }

    li {
      display: flex;
      gap: 12px;
      font-size: 15px;
      line-height: 1.55;
      color: var(--text-muted);
    }

    li svg {
      flex: none;
      margin-top: 3px;
      color: var(--coral);
    }
  }

  .tile-services {
    grid-column: span 7;
    background: var(--surface-butter);
  }

  @media (max-width: 960px) {
    .tile-foundation,
    .tile-objectives,
    .tile-services {
      grid-column: 1 / -1;
      grid-row: auto;
    }

    .tile-foundation svg {
      padding-bottom: 24px;
    }
  }

  @media (max-width: 600px) {
    .tile-objectives ul {
      grid-template-columns: 1fr;
    }
  }
`;

const Pills = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  li {
    padding: 10px 18px;
    border-radius: var(--radius-pill);
    background: var(--surface);
    border: 1px solid var(--border);
    font-weight: 600;
    font-size: 15px;
    transition:
      transform 0.35s var(--ease-out),
      border-color 0.2s ease;
  }

  li:hover {
    transform: translateY(-2px);
    border-color: var(--coral);
  }
`;

const Leadership = styled.div`
  margin-top: clamp(64px, 8vw, 96px);

  h3 {
    font-size: clamp(24px, 2.6vw, 30px);
  }

  > .reveal p {
    color: var(--text-muted);
    max-width: 68ch;
  }
`;

const Directory = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 32px 28px;
  margin-top: 36px;

  > div {
    padding-top: 18px;
    border-top: 2px solid var(--border);
    transition: border-color 0.3s ease;
  }

  > div:hover {
    border-top-color: var(--coral);
  }

  > .wide {
    grid-column: span 2;
  }

  @media (max-width: 960px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;

    > .wide {
      grid-column: auto;
    }
  }
`;

const Role = styled.div`
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 15px;
  color: var(--coral);
  margin-bottom: 12px;
`;

const People = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: ${({ $wide }) => ($wide ? "1fr 1fr" : "1fr")};
  gap: 14px 20px;

  li {
    display: flex;
    flex-direction: column;
  }

  strong {
    font-weight: 700;
  }

  span {
    font-size: 14px;
    color: var(--text-muted);
    line-height: 1.45;
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export default About;
